<div class="row" style="width:100%;margin:0 auto;">
  <div class="col-12">
    <mdb-card>
      <mdb-card-header class="bg-white ">
        <div class="headerCover">
          <div class="headerTilte app_list_header">
            <h5 class="m-0" class="mainHeadingStyle">Bill List</h5>
          </div>
          <div class="headerButtons">
            <div *ngIf="createFlag"><a *ngIf="billingType == 'patient' || billingType == 'dietician'  " (click)="create()" ><img src="../../../assets/ui_icons/buttons/new_button.svg" class="saveimgbtn_inpatinfo"></a></div>
            <div *ngIf="createFlag"><a *ngIf="billingType == 'Diagnosis'" (click)="digBillCreate()" ><img src="../../../assets/ui_icons/buttons/new_button.svg" class="saveimgbtn_inpatinfo"></a></div>
          </div>
        </div>
      </mdb-card-header>
      <mdb-card-body>
        <div class="row" *ngIf="this.type != 'Admin'">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 select_bottom">
            <mat-label class="matlabel">Billing Type<br>
              <!-- <option value="doctor">Out-Patient</option> -->
              <select required class="ipcss" [(ngModel)]="billingType" required (change)="changeBillingType()"
                disableOptionCentering>
                <option value="patient">Doctor</option>
                <option [hidden]="diagnosisFlag" value="dietician">Dietician</option>
                <option [hidden]="diagnosisFlag" value="Diagnosis">Diagnosis</option>
              </select>
            </mat-label>
          </div>
        </div>
        <div class="row" *ngIf="billingType != 'dietician'">
          <div class="col-12" style="margin-bottom: 5px;margin-top: 5px;">
            <div class="row">
              <div class="col-12">
                <div class="switch-field" *ngIf="ynopt1 != undefined">
                  <input type="radio" id="radio-three" (click)="change_type(1,'yes')" />
                  <label for="radio-three" [ngClass]="ynopt1 ? 'radio_active':'radio_inactive'">
                    <div class="tab_cover">
                      <div class="tab_icon_cover"><img src="../../../assets/ui_icons/Outpatient.svg" class="iocinStyle"
                          alt=""></div>
                      <div class="lableStyle">Out-patient</div>
                    </div>
                  </label>
                  <input type="radio" id="radio-four" (click)="change_type(1,'no')" />
                  <label for="radio-four" [ngClass]="!ynopt1 ? 'radio_active':'radio_inactive'">
                    <div class="tab_cover">
                      <div class="tab_icon_cover"><img src="../../../assets/ui_icons/Inpatient.svg" class="iocinStyle"
                          alt=""></div>
                      <div class="lableStyle">In-patient</div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="patientFlag">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 col-xxl-2 select_bottom">
              <mat-label class="matlabel">Filter by<br>
                <select required class="ipcss" [(ngModel)]="filter" required (change)="changeFilter()"
                  disableOptionCentering>
                  <option value="Patient ID">UHID</option>
                  <option value="Location">Location</option>
                  <option value="Name">Name</option>
                  <option value="Date">Date</option>
                </select>
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 col-xxl-2 select_bottom">
              <mat-label class="matlabel" [hidden]="toFlag">From<br>
                <input type="date" class="ipcss widthbilllist datecss" (change)="selectFromDate(fromDate)"
                  [hidden]="fromFlag" [(ngModel)]="fromDate" #matInput max="{{currentDate}}">
              </mat-label>
              <mat-label class="matlabel" [hidden]="cityFlag">City<br>
                <select required class="ipcss widthbilllist" [(ngModel)]="cityDesc" (change)="changeCity(cityDesc)"
                  disableOptionCentering>
                  <option *ngFor="let city of cityList" value={{city}}>{{city}}</option>
                </select>
              </mat-label>
              <mat-label class="matlabel" [hidden]="firstNameFlag">First name<br>
                <input matInput class="ipcss widthbilllist" type="text" [hidden]="firstNameFlag" required
                  [(ngModel)]="firstName" (blur)="fnameToUpper()" style="margin-bottom: 10px;" />
              </mat-label>
              <mat-label class="matlabel" [hidden]="uhidFlag  ">UHID<br>
                <input matInput class="ipcss widthbilllist" type="text" [hidden]="uhidFlag" required
                  [(ngModel)]="patientId" />
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2 col-xxl-2" *ngIf="!locationFlag || !toFlag || !firstNameFlag ">
              <mat-label class="matlabel" [hidden]="locationFlag">Location<br>
                <mat-select required [hidden]="locationFlag" class="ipcss widthbilllist" [(ngModel)]="location"
                  disableOptionCentering>
                  <mat-option *ngFor="let location of locationList" value={{location}}>{{location}}</mat-option>
                </mat-select>
              </mat-label>
              <mat-label class="matlabel" [hidden]="toFlag">To<br>
                <input type="date" class="ipcss widthbilllist datecss" id="appt_date"
                  (change)="selectToDate(toDate)" [hidden]="toFlag" [(ngModel)]="toDate" max="{{currentDate}}"
                  matInput>
              </mat-label>
              <mat-label class="matlabel" [hidden]="firstNameFlag">Last name<br>
                <input matInput class="ipcss widthbilllist" type="text" [hidden]="firstNameFlag" required
                  [(ngModel)]="lastName" (blur)="lnameToUpper()" />
              </mat-label>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2 select_bottom">
              <mat-label class="matlabel">
                Filter by
              </mat-label>
              <select required class="ipcss" [(ngModel)]="appType" required
                disableOptionCentering style="height: 28px;">
                <option value="all">All</option>
                <option value="New">New</option>
                <option value="follow">Follow-up</option>
              </select>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 d-flex align-items-center">
              <mat-label class="matlabel">
                <a (click)="searchBill()"><img src="../../../assets/ui_icons/buttons/search_button.svg"
                    class="saveimgbtn_inpatinfo topvalue" /></a>
              </mat-label>
            </div>
          </div>
          <div class="row" style="margin-top: 15px;">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <p class="nodata" *ngIf="billList.length == 0 && billingList.length == 0"  >No bill(s) found</p>
              <table *ngIf="billList.length" mdbTable datatable [dtOptions]="dtOptions" class="table table-nowrap table-sm billlisttable">
                <thead>
                  <tr>
                    <th class="delete">Bill no</th>
                    <th>Date</th>
                    <th>Client name</th>
                    <!-- <th>Pay type</th> -->
                    <th>Amount</th>
                    <th *ngIf="editFlag || deleteFlag" class="delete">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let bill of billList; let i = index">
                    <td style="font-size: 12px;text-align: center;"(click)="viewBill(bill.bill_id,bill.doc_reg_id, bill.fin_year)" >
                      {{bill.bill_id}}
                    </td>
                    <td style="font-size: 12px;text-align: center;" (click)="viewBill(bill.bill_id,bill.doc_reg_id, bill.fin_year)">
                      {{bill.date}}
                    </td>
                    <td style="font-size: 12px;text-align: left !important;" (click)="viewBill(bill.bill_id,bill.doc_reg_id, bill.fin_year)">
                      {{bill.salutation}} {{bill.client_name}}</td>
                    <td style="font-size: 12px;text-align: right;">
                      {{bill.amount}}
                    </td>
                    <td  style="font-size: 12px;text-align: center;" *ngIf="editFlag || deleteFlag">
                      <img  *ngIf="editFlag" src="../../../assets/img/edit.png" class="billing_edit" style="z-index: 9;" alt="" (click)="editBill(bill.bill_id,bill.doc_reg_id,bill.doc_app_id,bill.fin_year)"> &nbsp;&nbsp;
                      <img  *ngIf="deleteFlag" src="../../../assets/img/Delete.png" class="billing_edit" (click)="deleteBill(bill.bill_id, bill.fin_year)">
                    </td>
                  </tr>
                </tbody>
              </table>
              <table *ngIf="billingList.length" class="card_tbl table-dynamic" mdbTable datatable [dtOptions]="dtOptions" class="table table-nowrap table-sm billlisttable">
                <thead>
                  <tr>
                      <th>Bill no</th>
                      <th>Date</th>
                      <th>Client name</th>
                      <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let bill of billingList" (click)="inViewBill(bill.bill_id, bill.bill_cat, bill.provider_id, bill.fin_year)">
                      <td>{{bill.bill_id}}</td>
                      <td>{{bill.date}}</td>
                      <td class="align_left">{{bill.client_name}}</td>
                      <td class="align_right">{{bill.amount}}</td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div *ngIf="!patientFlag">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 select_bottom" [hidden]="doctorFlag">
              <mat-label class="matlabel">Doctor<br>
                <select [(ngModel)]="doctorId" class="ipcss">
                  <option>All</option>
                  <option *ngFor="let name of doctorList" value={{name.doctor_id}}>{{name.doctor_name}}</option>
                </select>
              </mat-label>
            </div>
            <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              <mat-label class="matlabel">From date<br>
                <input type="date" class="ipcss widthbilllist datecss" required [(ngModel)]="fromDate"
                  max="{{currentDate}}" matInput>
              </mat-label>
            </div>
            <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              <mat-label class="matlabel">To date<br>
                <input type="date" class="ipcss widthbilllist datecss" required [(ngModel)]="toDate"
                  max="{{currentDate}}" matInput>
              </mat-label>
            </div>
           
            <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 d-flex align-items-center">
              <mat-label class="matlabel">
                <a (click)="searchBill()"><img src="../../../assets/ui_icons/buttons/search_button.svg"
                    class="saveimgbtn_inpatinfo topvalue" /></a>
              </mat-label>
            </div>
          </div>
          <div [hidden]="billingList.length != 0" class="nodata">No bills found</div>
          <div [hidden]="billingList.length == 0" class="">
            <table *ngIf="billingList.length" class="card_tbl table-dynamic" mdbTable datatable [dtOptions]="dtOptions"
            class="table table-nowrap table-sm dataTable billlisttable">
              <thead>
                <tr>
                    <th>Bill no</th>
                    <th>Date</th>
                    <th>Client name</th>
                    <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let bill of billingList" (click)="inViewBill(bill.bill_id, bill.bill_cat, bill.provider_id, bill.fin_year)">
                    <td>{{bill.bill_id}}</td>
                    <td>{{bill.date}}</td>
                    <td class="align_left">{{bill.client_name}}</td>
                    <td class="align_right">{{bill.amount}}</td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </mdb-card-body>
    </mdb-card>
  </div>
</div>